/* eslint-disable */
import axios from 'axios'
import commonFuc from '@/utils/commonFuc.js'
import { Message } from 'element-ui'
let AES_ARR = [
    '/sys/validCode/obtain',//获取验证码
    '/opensaas/operationadmin/orgInfo/checkOrgsByPhone',//检测多机构
    '/sys/phone/login',//手机号登录
    '/opensaas/operationadmin/orgInfo/trailOrgAdd',//完善信息(创建试用机构)
]//需要AES加密的接口
axios.interceptors.request.use(function (request) {
    if (request.method === 'post') {
        //如果是教务调用，则在data里面添加一个sys=jiaowu的标识
        // if(sessionStorage.getItem('isJiaowu')&&sessionStorage.getItem('isJiaowu')=='true'){
        //     request.data.sys = 'isJiaowu';
        // }        
        if (request.method === 'post') {
            let _data = Object.assign({}, request.data, commonFuc.getSafeObj(request.data));
            for (let v of AES_ARR) {
                if (request.url.includes(v)) {
                    // console.log('-----加密前-----', request.data, _data)
                    _data = commonFuc.encryptMessage(JSON.stringify(_data))
                    break
                }
            }
            request.data = JSON.stringify(_data);
            request.headers['Content-Type'] = 'application/json;charset=UTF-8';
            // request.headers['User-Agent'] = 'Manhattan';
        }
    }
    return request
}, err => {
    return Promise.reject(err)
})

axios.interceptors.response.use(function (response) {
    let data = typeof response.data === 'string' ? { data: { text: response.data }, code: 200 } : response.data;
    if (response.status === 200 && (data.status === 0 || data.status === '0' || !data.status)) {
        data = (data.data && data.data !== "") ? data.data : data
        return data
    } else {
        if (data.code === "REQ007" || data.code === "REQ0011" || data.code === "AUTH001") { //前人的坑，状态码是这两个，处理返回对象 
            return data
        } else {
            return Promise.reject(response.data)
        }
    }
}, err => {
    // console.log("err", err.response.data.msg)
    let _err = err.response.status
    if (_err >= 500 || _err == 429) {
        Message.error({
            message: err.response.data.msg ? err.response.data.msg : '请求失败！'
        })
    }
    return Promise.reject(err)
})

export default {
    loginVerify: function (data, callback) {   //登录前校验
        return axios.post('/sys/login/verify', data).then((res) => {
            if (res) {
                callback(res)
            } else {
                Message.error({
                    message: err.msg
                })
            }
        }).catch(function (err) {
            if (window.coverLoadingTimer) {
                window.clearTimeout(window.coverLoadingTimer)
                window.coverLoadingTimer = null
            }
            if (window.loadingInstance) {
                window.loadingInstance.close();  //关闭登录遮罩
                window.loadingInstance = false
            }

            if (err && err.msg) {
                callback(false)
                Message.error({
                    message: err.msg
                })
            }
        })
    },
    loginIn: function (data, callback) {   //登录
        return axios.post('/sys/login', data, { timeout: 5000 }).then((res) => {
            if (res) {
                callback(res)
            } else {
                Message.error({
                    message: err.msg
                })
            }
        }).catch(function (err) {
            callback(false)
            if (err && err.msg) {
                Message.error({
                    message: err.msg
                })
            }
        })
    },
    hjxLoginVerify: function (data, callback) {   //慧简学登录前置校验接口
        return axios.post('/sys/login/hjxVerify', data).then((res) => {
            if (res) {
                callback(res)
            } else {
                Message.error({
                    message: err.msg
                })
            }
        }).catch(function (err) {
            if (window.coverLoadingTimer) {
                window.clearTimeout(window.coverLoadingTimer)
                window.coverLoadingTimer = null
            }
            if (window.loadingInstance) {
                window.loadingInstance.close();  //关闭登录遮罩
                window.loadingInstance = false
            }

            if (err && err.msg) {
                callback(false)
                Message.error({
                    message: err.msg
                })
            }
        })
    },
    hjxLoginIn: function (data, callback) {   //慧简学登录接口
        return axios.post('/sys/hjxLogin', data, { timeout: 5000 }).then((res) => {
            if (res) {
                callback(res)
            } else {
                Message.error({
                    message: err.msg
                })
            }
        }).catch(function (err) {
            callback(false)
            if (err && err.msg) {
                Message.error({
                    message: err.msg
                })
            }
        })
    },
    savePasswordStatus: function (data, callback) {   //保存修改密码状态
        return axios.post('sys/user/resetUserPasswd', data).then((res) => {
            if (res) {
                callback(res)
            } else {
                Message.error({
                    message: '请求失败'
                })
            }
        }).catch(function (err) {
            Message.error({
                message: err.msg
            })
        })
    },
    saveUserVerify: function (data, callback) { // 重置密码后发送校验api, 下次登录的时候识别同一个设备，就不需要弹出短信验证接受
        return axios.post('sys/login/edit/user/verify', data).then((res) => {
            if (res) {
                callback(res)
            } else {
                Message.error({
                    message: '请求失败'
                })
            }
        }).catch(function (err) {
            Message.error({
                message: err.msg
            })
        })
    },
    sendCode: function (data, callback) {   // 发送验证码
        return axios.post('/sys/validCode/get', data).then((res) => {
            if (res) {
                callback(true)
            } else {
                Message.error({
                    message: '请求失败'
                })
            }
        }).catch(function (err) {
            console.log(err)
            callback(false)
            Message.error({
                message: err.msg
            })
        })
    },
    getSendCode: function (data, callback) {   // 登录发送验证码
        return axios.post('/sys/validCode/login/get', data).then((res) => {
            if (res) {
                callback(res)
            } else {
                Message.error({
                    message: '请求失败'
                })
            }
        }).catch(function (err) {
            console.log(err)
            callback(false)
            Message.error({
                message: err.msg
            })
        })
    },
    getValidCode: function (data, callback) {   // 手机号登录发送验证码
        return axios.post('/sys/validCode/obtain', data).then((res) => {
            if (res) {
                callback(res)
            } else {
                Message.error({
                    message: '请求失败'
                })
            }
        }).catch(function (err) {
            console.log(err)
            callback(false)
            Message.error({
                message: err.msg
            })
        })
    },
    orgRegister: async function (data, callback) {   // 机构免费注册
        return axios.post(process.env.VUE_APP_LOCALTION_GREY_URL + '/opensaas/hjx/website/register', data).then((res) => {
            if (res) {
                callback(res)
                return res
            } else {
                Message.error({
                    message: '请求失败'
                })
            }
        }).catch(function (err) {
            console.log(err)
            callback(false)
            Message.error({
                message: err.msg
            })
            return false
        })
    },
    trailOrgAdd: function (data, callback) {   // 完善机构信息
        return axios.post(process.env.VUE_APP_LOCALTION_GREY_URL + '/opensaas/operationadmin/orgInfo/trailOrgAdd', data).then((res) => {
            if (res) {
                callback(res)
            } else {
                Message.error({
                    message: '请求失败'
                })
            }
        }).catch(function (err) {
            console.log(err)
            callback(false)
            Message.error({
                message: err.msg
            })
        })
    },
    checkOrgsByPhone: async function (data, callback) {   //手机号登录前多租户检查
        return axios.post(process.env.VUE_APP_LOCALTION_GREY_URL + `/opensaas/operationadmin/orgInfo/checkOrgsByPhone`, data).then((res) => {
            if (res) {
                if (callback) {
                    callback(res)
                }
            } else {
                Message.error({
                    message: '请求失败'
                })
            }
            return res
        }).catch(function (err) {
            Message.error({
                message: err.msg
            })
            return false
        })
    },
    phoneLogin: function (data, callback) {   // 手机号登录
        return axios.post('/sys/phone/login', data).then((res) => {
            if (res) {
                callback(res)
            } else {
                callback(false)
                Message.error({
                    message: '请求失败'
                })
            }
        }).catch(function (err) {
            console.log(err)
            callback(false)
            Message.error({
                message: err.msg
            })
        })
    },
    getBackPassword: function (data, callback) {   // 找回密码
        return axios.post('/sys/user/updatePasswdByPhone', data).then((res) => {
            if (res) {
                callback(true)
            } else {
                Message.error({
                    message: '请求失败'
                })
            }
        }).catch(function (err) {
            callback(false)
            Message.error({
                message: err.msg
            })
        })
    },
    getBindPhoneStatus: function (data, callback) {   // 绑定手机
        return axios.post('/sys/user/bindPhone', data).then((res) => {
            if (res) {
                callback(true)
            } else {
                Message.error({
                    message: '请求失败'
                })
            }
        }).catch(function (err) {
            callback(false)
            Message.error({
                message: err.msg
            })
        })
    },
    getQrcode: function (data, callback) {   //随机二维码id
        return axios.post(process.env.VUE_APP_LOCALTION_URL + '/core/crm/user/qrcode', data).then((res) => {
            if (res) {
                callback(res)
            } else {
                Message.error({
                    message: '请求失败'
                })
            }
        }).catch(function (err) {
            callback(err)
            Message.error({
                message: err.msg
            })
        })
    },
    getQrcodeScanResult: function (data, callback) {   //扫码后回调，2s调一次
        return axios.post(process.env.VUE_APP_LOCALTION_URL + '/core/crm/user/qrcodeScanResult', data).then((res) => {
            if (res) {
                callback(res)
            } else {
                callback(false)
                Message.error({
                    message: '请求失败'
                })
            }
        }).catch(function (err) {
            callback(false)
            Message.error({
                message: err.msg
            })
        })
    },
    getDestroyQrcode: function (data, callback) {   //销毁二维码
        return axios.post(process.env.VUE_APP_LOCALTION_URL + '/core/crm/user/destroyQrcode', data).then((res) => {
            if (res) {
                callback(res)
            } else {
                Message.error({
                    message: '请求失败'
                })
            }
        }).catch(function (err) {
            callback(err)
            Message.error({
                message: err.msg
            })
        })
    },
    getOrgInfo: async function (data, callback) {   //获取机构基本信息(登录前)
        console.log('url----', process.env.VUE_APP_LOCALTION_GREY_URL)
        // return axios.post(process.env.VUE_APP_LOCALTION_GREY_URL + `/opensaas/client/getOrgInfo/${data.rentId}`).then( (res) =>{
        return axios.post(process.env.VUE_APP_STUDY_URL + `/study/sys/tenant/getTenantInfo`, data).then((res) => {
            if (res) {
                if (callback) {
                    callback(res)
                }
            } else {
                Message.error({
                    message: '请求失败'
                })
            }
            return res
        }).catch(function (err) {
            if (callback) {
                callback(err)
            }
            Message.error({
                message: err.msg
            })
            return false
        })
    },
}